<script lang="ts">
    export let size: number = 24;
    export let color: string = '#333';
</script>

<svg class="w-5 h-5" viewBox="0 0 24 24" width={size} height={size} fill={color}>
    <path d="M9 18l6-6-6-6"></path>
</svg>